<template>
    <div class="w-1/2">
        <table class="w-full">
            <thead class="text-sm">
            <tr class="border bg-white">
                <th rowspan="2" class="py-2 border w-1/12">Item Code</th>
                <th rowspan="2" class="py-2 border w-2/12">Description</th>
                <th rowspan="2" class="py-2 border w-1/12">Unit</th>
                <th colspan="4" class="py-2 border w-6/12">QTY</th>
                <th rowspan="2" class="py-2 border w-2/12">Total</th>
            </tr>
            <tr class="border bg-gray-100">
                <th class="py-1 border w-1/12">Pending Open</th>
                <th class="py-1 border w-1/12">Pending Approved</th>
                <th class="py-1 border w-1/12">Pending Invoiced</th>
                <th class="py-1 border w-1/12">Completed</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in reportData" class="border border-b bg-white text-sm">
                <td class="px-2 py-2">{{ row.item_code }}</td>
                <td class="px-2 py-2">{{ row.description }}</td>
                <td class="px-2 py-2">{{ row.unit }}</td>
                <td class="px-2 py-2 bg-gray-100 text-right">{{ row.open }}</td>
                <td class="px-2 py-2 bg-gray-200 text-right">{{ row.approved }}</td>
                <td class="px-2 py-2 bg-gray-200 text-right">{{ row.invoiced }}</td>
                <td class="px-2 py-2 bg-green-100 text-right">{{ row.handover }}</td>
                <td class="px-2 py-2 text-right">{{ row.total }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
  export default {
    name: 'ProductOrderQtyReport',

    mounted() {
      this.fetchData()
    },

    data() {
      return {
        reportData : null
      }
    },

    methods: {
      fetchData() {
        this.$http.get(this.route('admin.reports.products')).then(response => {
          this.reportData = response.data;
        })
      }
    }
  }
</script>
